import { useState } from 'react';
import { filterHeaders } from './const'
import { updateModal } from '../../../../store/common/common_action'
import { connect } from 'react-redux'
import { useEffect } from 'react';
import { TableComponent } from '../../../common/TableComponent';
import { xlColq } from '../../../common/constants';

const BkngDelvryTrackingTableTwo = (props) => {
    const { dataValues,filterObj,reportName,columns } = props
    const { trackingReportTableData} = dataValues
    const [tableData, setTableData] = useState([])

    const detailedHeaders = columns.map((col) => {
        let headerText = col.header || ''
        headerText = headerText
            .split('\n')
            .map(line =>
                line
                    .trim()
                    .replace(/ /g, '\u00A0')
            )
            .slice(0, 2)
            .join('\n')

        return {
            ...col,
            header: headerText,
            exportHead: headerText,
            align:col.align || (col.xlCol?.dataType === 'quantity'? 'right': 'left'),
            weight: Math.max(col.weight || 0, 140),
        }
    })
    useEffect(() => {

        if (!trackingReportTableData?.length) {
            setTableData([])
            return
        }

        const newData = trackingReportTableData.map((item, index) => ({

            ...item,
            SN:index+1,
            CartageCharge:
                Number(item.PickupCartage || 0) +
                Number(item.CommCartage || 0) +
                Number(item.ReturnCartage || 0) +
                Number(item.MsclCart || 0) +
                Number(item.DeliveryCartage || 0),
            'LRNO^^ManualLRNo':`${item.LRNO ?? ''}\n${item.ManualLRNo ?? ''}`,
            'SourceCity^^SourceBranch':`${item.SourceCity ?? ''}\n${item.SourceBranch ?? ''}`,
            'DestCity^^DestBranch':`${item.DestCity ?? ''}\n${item.DestBranch ?? ''}`,
            'Sender^^SenderMobileNo':`${item.Sender ?? ''}\n${item.SenderMobileNo ?? ''}`,
            'RecName^^RecMobileNo':`${item.RecName ?? ''}\n${item.RecMobileNo ?? ''}`,
            'PartyBillNo^^PartyBillDate':`${item.PartyBillNo ?? ''}\n${item.PartyBillDate ?? ''}`,
            BookingDate: item?.BookingDate?.split(' ')[0] || '',
            BookingTime: item?.BookingDate?.split(' ').slice(1).join(' ') || '',
            RefundDate: item?.RefundDate?.split(' ')[0] || '',
            RefundTime: item?.RefundDate?.split(' ').slice(1).join(' ') || '',
             dataType: 'entry',

        }))

        // ✅ total row
        const totalRow = calculateTotal(newData, columns)

        setTableData([...newData, totalRow])

    }, [trackingReportTableData])
    const calculateTotal = (data = [], columns = []) => {
        if (!data.length || !columns.length) return {}
        const visibleHeaders = columns.filter(
            col => col.isSelected !== false
        )
        const numericCols = visibleHeaders.filter(
            col => col.xlCol === xlColq
        )

        const totalFields = numericCols.map(col => col.field)

        // ✅ first column where total start
        const firstNumericIndex = visibleHeaders.findIndex(
            col => col.xlCol === xlColq
        )

        // ✅ first column of table
        const firstField = visibleHeaders[0]?.field

        let totalRow = {
            dataType: 'total',

            [firstField]: 'Total',

            colSpan: {
                [firstField]:
                    firstNumericIndex > 0 ? firstNumericIndex : 1
            }
        }

        // ✅ initialize totals
        totalFields.forEach(field => {
            totalRow[field] = 0
        })
        data.forEach(row => {

            totalFields.forEach(field => {

                let value = row[field]

                if (
                    (field === 'AWEIGHT' || field === 'CWEIGHT') &&
                    typeof value === 'string'
                ) {
                    value = value
                        ?.split(',')
                        ?.reduce((a, b) => a + Number(b || 0), 0)
                }

                totalRow[field] = Number(
                    (
                        Number(totalRow[field] || 0) +
                        Number(value || 0)
                    ).toFixed(2)
                )
            })

        })

        return totalRow
    }
    return (
        <>
            {tableData.length ? (
                <TableComponent
                    reportName={reportName}
                    criteriaHeaders={filterHeaders}
                    criteriaData={[filterObj]}
                    tableData={tableData}
                    mainHeader={detailedHeaders}
                    isShowPdfPrint={false}
                />
            ) : (
                <></>
            )}
        </>
        
    )
}


const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(BkngDelvryTrackingTableTwo)
